import { render, staticRenderFns } from "./KerkenLegend.vue?vue&type=template&id=7831f29c&scoped=true"
import script from "./KerkenLegend.vue?vue&type=script&lang=js"
export * from "./KerkenLegend.vue?vue&type=script&lang=js"
import style0 from "./KerkenLegend.vue?vue&type=style&index=0&id=7831f29c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7831f29c",
  null
  
)

export default component.exports